import PlanetStage from "../PlanetGenerator/Planet";

export default function Stage({ solar, textures, cur, isConnect, children }) {
  const visibleSolar = isConnect ? solar.filter((p) => p.id !== "connect") : solar;

  return (
    <div id="stage" className={isConnect ? "stage-connect" : ""}>
      {visibleSolar.map((p, i) => {
        const tex = textures[p.id];
        const aspect = tex?.aspect || 2;
        const texW = `calc(var(--ps) * ${aspect.toFixed(4)})`;
        const isOn = i === cur;

        return <PlanetStage key={p.id} planet={p} tex={tex ? { url: tex.url, texW } : null} isOn={isOn} />;
      })}
      {children}
    </div>
  );
}
